//
//
//
//
//
//
//
//
//
//
export default {
  mounted: function mounted() {
    document.body.classList.add('background');
  },
  beforeDestroy: function beforeDestroy() {
    document.body.classList.remove('background');
  }
};